<template>
  <div class="w-full pt-5 pb-5">
    <div class="flex">
      <div>
        <h1 class="text-xl text-left font-extrabold ml-4 mt-3">
          Overtime
        </h1>
      </div>
    </div>
    <div class="px-3">
      <div class="w-full">
        <div class="mt-8">
          <Tab
            :tabs="['Planned Work', 'Overtime Pay']"
            border
            :active-tab="currentTab"
            @currentTab="currentTab = $event"
          />
        </div>
        <planned-work v-if="currentTab === 'Planned Work'" mode="ess"/>
        <overtime-pay v-if="currentTab === 'Overtime Pay'" mode="ess"/>
      </div>
    </div>
  </div>
</template>

<script>
import Tab from "@scelloo/cloudenly-ui/src/components/tab";
import PlannedWork from "@/modules/Admin/BenefitsModule/Overtime/plannedWork";
import OvertimePay from "@/modules/Admin/BenefitsModule/Overtime/overtimePay";

export default {
  name: "ManagerOvertimeRequests",
  components: {
    Tab,
    PlannedWork,
    OvertimePay,
  },
  data() {
    return {
      currentTab: "Planned Work",
      showError: false
    };
  },
  methods: {
  },
  mounted() {
  }
};
</script>
